import { render, staticRenderFns } from "./LProjectNotifications.vue?vue&type=template&id=5d74f710&scoped=true&"
import script from "./LProjectNotifications.vue?vue&type=script&lang=js&"
export * from "./LProjectNotifications.vue?vue&type=script&lang=js&"
import style0 from "./LProjectNotifications.vue?vue&type=style&index=0&id=5d74f710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d74f710",
  null
  
)

export default component.exports